import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Al iniciar, intentar recuperar sesión guardada
  useEffect(() => {
  try {
    const tokenGuardado = localStorage.getItem("token");
    const usuarioGuardado = localStorage.getItem("usuario");
    if (tokenGuardado && usuarioGuardado) {
      const usuarioParsed = JSON.parse(usuarioGuardado);
      // Verificar que tenga la estructura mínima esperada
      if (usuarioParsed?.id && usuarioParsed?.rol) {
        setToken(tokenGuardado);
        setUsuario(usuarioParsed);
      } else {
        // Dato corrupto o manipulado — limpiar
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
      }
    }
  } catch (e) {
    // JSON inválido — limpiar localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
  } finally {
    setCargando(false);
  }
}, []);

  const login = (datosUsuario, accessToken) => {
    setUsuario(datosUsuario);
    setToken(accessToken);
    localStorage.setItem("token", accessToken);
    localStorage.setItem("usuario", JSON.stringify(datosUsuario));
  };

  const logout = () => {
    setUsuario(null);
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
  };

  const esAdmin = () => usuario?.rol === "admin";
  const esCliente = () => usuario?.rol === "cliente";

  return (
    <AuthContext.Provider value={{
      usuario,
      token,
      cargando,
      login,
      logout,
      esAdmin,
      esCliente
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;